// Minimum time overlay should be displayed
const INSURANCE_OVERLAY_MINIMUM_MILLISECONDS = 5000

// Calculates duration in milliseconds to keep showing the insurance verification overlay
export const getRemainingOverlayTime = (
  startTimestamp: number | undefined
): number => {
  if (startTimestamp === undefined) {
    return 0
  }
  const timeElapsed = new Date().getTime() - startTimestamp
  const remainingTime = INSURANCE_OVERLAY_MINIMUM_MILLISECONDS - timeElapsed
  return remainingTime > 0 ? remainingTime : 0
}
